module.exports = __webpack_public_path__ + "img/sms.904b27d5.svg";